<template>
  <div class="dizme_tm_section" id="მომსახურება">
    <div class="dizme_tm_services">
      <div class="container">
        <div class="dizme_tm_main_title" data-align="center">
          <span>მომსახურება</span>
          <h3>პაკეტები და ფასები</h3>
          <p>
            გთავაზობთ მრავალფეროვან პაკეტებს, რომლებიც განსხვავებული
            საჭიროებებისა და ბიუჯეტების მიხედვით არის შექმნილი.
            შეარჩიეთ თქვენთვის იდეალური ვარიანტი.
          </p>
        </div>
        <div class="service_list">
          <ul>
            <li
              class="wow fadeInLeft"
              data-wow-duration="2s"
            >
              <div class="list_inner tilt-effect">
                <div class="title">
                  <h3>ეკონომი</h3>
                  <span class="price"><span>1000₾</span></span>
                </div>
                <div class="text">
                  <p>
                    გადაღება კამერით და დრონით
                  </p>
                  <p>
                    ერთი ვიდეოგრაფი
                  </p>
                  <p>
                    სამუშაო დრო 10-12 სთ.
                  </p>
                  <p>
                    დამუშავებული ვიდეო 5-10 წთ.
                  </p>
                  <p>
                    დამუშავების დრო 15 დღე
                  </p>
                </div>
              </div>
            </li>
            <li
              class="wow fadeInRight"
              data-wow-duration="2s"
              data-wow-delay="0.5s"
            >
              <div class="list_inner tilt-effect">
                <div class="title">
                  <h3>სტანდარტი</h3>
                  <span class="price"><span>1500₾</span></span>
                </div>
                <div class="text">
                  <p>
                    გადაღება კამერით და დრონით
                  </p>
                  <p>
                    ერთი ვიდეოგრაფი
                  </p>
                  <p>
                    სამუშაო დრო 10-12 საათი
                  </p>
                  <p>
                    დამუშავებული ვიდეო 3-5 წთ.
                  </p>
                  <p>
                    დამუშავებული ვიდეო 60-90 წთ.
                  </p>
                  <p>
                    დამუშავების დრო 2 თვე
                  </p>
                </div>
                <div class="service_hidden_details">
                  <div class="service_popup_informations">
                    <div class="descriptions">
                      <p>
                        Dizme is a leading web design agency with an
                        award-winning design team that creates innovative,
                        effective websites that capture your brand, improve your
                        conversion rates, and maximize your revenue to help grow
                        your business and achieve your goals.
                      </p>
                      <p>
                        In today’s digital world, your website is the first
                        interaction consumers have with your business. That's
                        why almost 95 percent of a user’s first impression
                        relates to web design. It’s also why web design services
                        can have an immense impact on your company’s bottom
                        line.
                      </p>
                      <p>
                        That’s why more companies are not only reevaluating
                        their website’s design but also partnering with Kura,
                        the web design agency that’s driven more than $2.4
                        billion in revenue for its clients. With over 50 web
                        design awards under our belt, we're confident we can
                        design a custom website tha-t drives sales for your
                        unique business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li
              class="wow fadeInLeft"
              data-wow-duration="2s"
              data-wow-delay="0.5s"
            >
              <div class="list_inner tilt-effect">
                <div class="title">
                  <h3>პრემიუმი</h3>
                  <span class="price"><span>2000₾</span></span>
                </div>
                <div class="text">
                  <p>
                    გადაღება 2 კამერით და დრონით
                  </p>
                  <p>
                    ორი ვიდეოგრაფი
                  </p>
                  <p>
                    სამუშაო დრო 10-12 სთ.
                  </p>
                  <p>
                    დამუშავებული ვიდეო 3-5 წთ.
                  </p>
                  <p>
                    დამუშავებული ვიდეო 60-90 წთ.
                  </p>
                  <p>
                    დამუშავების დრო 2 თვე
                  </p>
                </div>
                <div class="service_hidden_details">
                  <div class="service_popup_informations">
                    <div class="descriptions">
                      <p>
                        Dizme is a leading web design agency with an
                        award-winning design team that creates innovative,
                        effective websites that capture your brand, improve your
                        conversion rates, and maximize your revenue to help grow
                        your business and achieve your goals.
                      </p>
                      <p>
                        In today’s digital world, your website is the first
                        interaction consumers have with your business. That's
                        why almost 95 percent of a user’s first impression
                        relates to web design. It’s also why web design services
                        can have an immense impact on your company’s bottom
                        line.
                      </p>
                      <p>
                        That’s why more companies are not only reevaluating
                        their website’s design but also partnering with Kura,
                        the web design agency that’s driven more than $2.4
                        billion in revenue for its clients. With over 50 web
                        design awards under our belt, we're confident we can
                        design a custom website that drives sales for your
                        unique business.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="brush_1 wow fadeInLeft" data-wow-duration="1s">
        <img src="/img/brushes/service/5.png" alt="საუკეთესო ვიდეოგრაფი საქართველოში" />
      </div>
      <div class="brush_2 wow zoomIn" data-wow-duration="1s">
        <img src="/img/brushes/service/6.png" alt="ვიდეო გადაღება 4K ხარისხში" />
      </div>
    </div>
  </div>
  <div :class="active == 1 ? '' : 'service_hidden_details'">
    <ModalBox :close="close">
      <div class="service_popup_informations">
        <div class="image">
          <img src="img/thumbs/4-2.jpg" alt="კრეატიული ვიდეოგრაფია და მონტაჟი" />
          <div
            class="main"
            data-img-url="img/service/1.jpg"
            style="background-image: url('img/service/1.jpg')"
          ></div>
        </div>
        <div class="main_title">
          <h3>ეკონომი</h3>
          <span class="price">ფასი <span>1000₾</span></span>
        </div>
        <div class="descriptions">
          <p>
            <b> ✔️ ერთი ოპერატორი: </b> პროფესიონალი ოპერატორი,
            რომელიც სრულად გააშუქებს მნიშვნელოვან მომენტებს.
          </p>
          <p>
            <b> ✔️ კამერა და დრონი: </b> მაღალი ხარისხის გადაღება ერთი 
            კამერით და დრონით
          </p>
          <p>
            <b> ✔️ სამუშაო დრო: </b> 10-12 საათი გადაღებისთვის.
          </p>
          <p>
            <b> ✔️ დამუშავებული ვიდეო: </b> 5-10 წუთიანი მაღალი ხარისხის მზა ვიდეო.
          </p>
          <p>
            <b> ✔️ ვიდეოს მონტაჟი: </b> მზა ვიდეოს მიწოდება 15 დღის ვადაში.
          </p>
        </div>
      </div>
    </ModalBox>
  </div>
  <div :class="active == 2 ? '' : 'service_hidden_details'">
    <ModalBox :close="close">
      <div class="service_popup_informations">
        <div class="image">
          <img src="img/thumbs/4-2.jpg" alt="პროფესიონალური კამერით გადაღებული ვიდეო" />
          <div
            class="main"
            data-img-url="img/service/2.jpg"
            style="background-image: url('img/service/2.jpg')"
          ></div>
        </div>
        <div class="main_title">
          <h3>სტანდარტი</h3>
          <span class="price">ფასი <span>1500₾</span></span>
        </div>
        <div class="descriptions">
          <p>
            Dizme is a leading web design agency with an award-winning design
            team that creates innovative, effective websites that capture your
            brand, improve your conversion rates, and maximize your revenue to
            help grow your business and achieve your goals.
          </p>
          <p>
            In today’s digital world, your website is the first interaction
            consumers have with your business. That's why almost 95 percent of a
            user’s first impression relates to web design. It’s also why web
            design services can have an immense impact on your company’s bottom
            line.
          </p>
          <p>
            That’s why more companies are not only reevaluating their website’s
            design but also partnering with Kura, the web design agency that’s
            driven more than $2.4 billion in revenue for its clients. With over
            50 web design awards under our belt, we're confident we can design a
            custom website that drives sales for your unique business.
          </p>
        </div>
      </div>
    </ModalBox>
  </div>
  <div :class="active == 3 ? '' : 'service_hidden_details'">
    <ModalBox :close="close">
      <div class="service_popup_informations">
        <div class="image">
          <img src="img/thumbs/4-2.jpg" alt="უნიკალური ვიდეო გადაღება ნებისმიერი ღონისძიებისთვის" />
          <div
            class="main"
            data-img-url="img/service/3.jpg"
            style="background-image: url('img/service/3.jpg')"
          ></div>
        </div>
        <div class="main_title">
          <h3>პრემიუმი</h3>
          <span class="price">ფასი <span>2000₾</span></span>
        </div>
        <div class="descriptions">
          <p>
            Dizme is a leading web design agency with an award-winning design
            team that creates innovative, effective websites that capture your
            brand, improve your conversion rates, and maximize your revenue to
            help grow your business and achieve your goals.
          </p>
          <p>
            In today’s digital world, your website is the first interaction
            consumers have with your business. That's why almost 95 percent of a
            user’s first impression relates to web design. It’s also why web
            design services can have an immense impact on your company’s bottom
            line.
          </p>
          <p>
            That’s why more companies are not only reevaluating their website’s
            design but also partnering with Kura, the web design agency that’s
            driven more than $2.4 billion in revenue for its clients. With over
            50 web design awards under our belt, we're confident we can design a
            custom website that drives sales for your unique business.
          </p>
        </div>
      </div>
    </ModalBox>
  </div>
</template>

<script>
import ModalBox from "./popup/ModalBox.vue";
export default {
  name: "ServiceCompoent",
  data() {
    return {
      active: 0,
    };
  },
  mounted() {
    let VanillaTilt = require("vanilla-tilt");
    VanillaTilt.init(document.querySelectorAll(".tilt-effect"), {
      maxTilt: 6,
      easing: "cubic-bezier(.03,.98,.52,.99)",
      speed: 500,
      transition: true,
    });
  },
  methods: {
    close() {
      this.active = 0;
    },
  },
  components: { ModalBox },
  props: {
    dark: { type: Boolean },
  },
};
</script>
